<template>
    <v-container class="contact px-0 pt-3 pb-0">
        <v-card class="pt-2 px-2 pb-4"
                flat
                tile>
            <div class="d-flex flex-row align-center mb-2">
                <back-button/>
            </div>

            <error-list :errors="errors"></error-list>

            <build-form :title="$vuetify.lang.t('$vuetify.contact_form.title')"
                        :description="$vuetify.lang.t('$vuetify.contact_form.text')"
                        :form-items="items"
                        :actions="actions"
                        :rules="rules"
                        :form.sync="form"
                        ref="form"
                        class="px-2"/>

        </v-card>
    </v-container>
</template>

<script>
    // 3rd
    import {
        mapActions,
        mapState,
    } from 'vuex';
    // models
    import User from '../models/User';
    // components
    import BuildForm from '../components/Builders/BuildForm';
    import BackButton from '../components/BackButton';
    import ErrorList from '../components/ErrorList';
    // utils
    import {
        LOADER_SUBMIT_CONTACT,
        ROUTE_CONFIRMATION,
    } from '../utils/constants';
    import {
        setPageTitle,
        redirect,
        transformArrayToSelectValues,
    } from '../utils/helper';
    import {
        errorHandler,
    } from '../utils/api';

    import {
        message,
        subject,
        topic,
    } from '../utils/formRules';

    export default {
        name: 'contact',
        components: {
            BuildForm,
            BackButton,
            ErrorList
        },
        data() {
            return {
                errors: {},
                form: {
                    topic: '',
                    subject: '',
                    message: '',
                },
                rules: {
                    topic,
                    subject,
                    message,
                },
            }
        },
        computed: {
            ...mapState([
                'contactTopics',
            ]),
            items() {
                return [
                    {
                        is: 'select',
                        name: 'topic',
                        options: this.topics,
                    },
                    {
                        is: 'text',
                        name: 'subject',
                    },
                    {
                        is: 'textarea',
                        name: 'message',
                    },
                ]
            },
            actions() {
                return [
                    {
                        is: 'button',
                        name: 'submit_contact',
                        color: 'primary',
                        clickMethod: this.submit,
                    },
                ]
            },
            topics() {
                return transformArrayToSelectValues(this.contactTopics, '$vuetify.contact_topics.');
            },
        },
        methods: {
            ...mapActions('confirmation', [
                'writeConfirmation',
            ]),
            async submit() {
                let result = null;
                try {
                    result = await User.submitContactForm(this.form);
                } catch (e) {
                    this.errors = errorHandler(e);
                    return;
                }

                const { data: { message } } = result;
                this.writeConfirmation({
                    headline: '$vuetify.confirmation.send_contact',
                    description: message,
                });
                redirect(ROUTE_CONFIRMATION);
            },
            resetForm() {
                this.$wait.end(LOADER_SUBMIT_CONTACT);
                this.form.subject = '';
                this.form.topic = '';
                this.form.message = '';
                // this.$refs.form.resetValidation();
            },
        }
    }
</script>
